<script setup>
import i18next from 'i18next';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
    filterLabel: {
        type: String,
        default: ''
    },
    dropdownValues: {
        type: Array,
        default: () => []
    },
    selectedDropdownValue: [String, Number, null]
});

const emit = defineEmits(['update:selectedDropdownValue', 'change']);

const dropdownOpen = ref(false);
const dropdownRef = ref(null);

const getSelectedLabel = computed(() => {
    const selected = props.dropdownValues.find((opt) => opt.key === props.selectedDropdownValue);

    return selected ? selected.title : props.filterLabel || i18next.t('plain_all');
});

const toggleDropdown = () => {
    dropdownOpen.value = !dropdownOpen.value;
};

const selectOption = (value) => {
    emit('update:selectedDropdownValue', value);
    emit('change', value);
    dropdownOpen.value = false;
};

const handleClickOutside = (event) => {
    if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        dropdownOpen.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
});
</script>

<template>
    <div ref="dropdownRef" class="relative w-full bg-dashboard-primary rounded-lg shadow-sm hover:shadow-md transition duration-300">
        <div class="w-full px-3 py-5 border text-xs rounded-xl shadow-sm cursor-pointer flex items-center h-[38px]" @click="toggleDropdown">
            {{ getSelectedLabel }}
        </div>

        <div v-if="dropdownOpen" class="absolute left-0 w-full bg-white shadow-lg text-xs rounded-xl border border-white mt-1 p-2 z-[90] max-h-[400px] overflow-y-auto">
            <p class="cursor-pointer px-3 border-b-2 transition hover:bg-blue-light duration-300 py-2 rounded-lg" @click="selectOption(null)">
                {{ $t('plain_all') }}
            </p>
            <p
                v-for="option in dropdownValues"
                :key="option.key"
                class="cursor-pointer px-3 border-b-2 border-white transition hover:bg-blue-light rounded-lg duration-300 py-2"
                @click="selectOption(option.key)"
            >
                {{ option.title }}
            </p>
        </div>

        <i v-if="dropdownOpen" class="fi fi-rr-angle-up absolute text-xs top-3 right-3 cursor-pointer" @click="dropdownOpen = false"></i>
        <i v-else class="fi fi-rr-angle-down absolute text-xs top-3 right-3 cursor-pointer" @click="dropdownOpen = true"></i>
    </div>
</template>
